import { configureStore } from "@reduxjs/toolkit";
import {
  bpDashboardReducer,
  ccmDashboardReducer,
  adminDashboardReducer,
} from "./slices/dashboard";
import {
  sharedExtensionReducer,
  bpExtensionReducer,
  ccmExtensionReducer,
  logsExtensionReducer,
  errorsExtensionReducer,
  actionsExtensionReducer,
} from "./slices/extension";
import {
  dealersReducer,
  productsReducer,
  machinesReducer,
} from "./slices/dataManagement";
import excelReducer from "./reducers/excelReducer";
import notificationReducer from "./slices/dashboard/notificationSlice";
import userReducer from "./reducers/userReducer";
import bkpReducer from "./slices/interestBearing/bkpReducer";
import customRatesReducer from "./slices/interestBearing/customRatesReducer";
import ratesStatusReducer from "./slices/interestBearing/ratesStatusReducer";

const store = configureStore({
  reducer: {
    bpDashboard: bpDashboardReducer,
    ccmDashboard: ccmDashboardReducer,
    adminDashboard: adminDashboardReducer,
    sharedExtension: sharedExtensionReducer,
    bpExtension: bpExtensionReducer,
    ccmExtension: ccmExtensionReducer,
    logsExtension: logsExtensionReducer,
    errorsExtension: errorsExtensionReducer,
    actionsExtension: actionsExtensionReducer,
    dealers: dealersReducer,
    products: productsReducer,
    machines: machinesReducer,
    excelState: excelReducer,
    notificationState: notificationReducer,
    userState: userReducer,
    bkpState: bkpReducer,
    customRatesState: customRatesReducer,
    ratesStatusState: ratesStatusReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  devTools: process.env.NODE_ENV !== 'production',
});

export default store;
